import React from 'react';

const ArrowDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path d="M7 14l5-5 5 5z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

export default ArrowDown;



// WEBPACK FOOTER //
// ./src/Components/UI/Icons/ArrowDown.js